import { PaymentMethod, PaymentSystem } from 'modules/purchase/constants'
import { logSuccessfulPayment } from 'modules/purchase/helpers/rootHelpers'

import { IUpiPurchaseData } from 'models/user.model'

export const logSuccessfulUpiPayment = ({
  upiPurchaseData,
  uuid,
  email,
}: {
  upiPurchaseData: IUpiPurchaseData
  uuid: string
  email: string
}): void =>
  logSuccessfulPayment({
    ...upiPurchaseData,
    uuid,
    email,
    paymentMethod: PaymentMethod.UPI,
    paymentSystem: PaymentSystem.STRIPE,
  })
